module.exports = __webpack_public_path__ + "static/media/press.2f33b9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/press.png
// module id = 18
// module chunks = 0